import React, { useContext } from 'react';
import { IStepModuleProps, ModuleSearchParam } from '../../../models/modules';
import { ISearchParams } from 'src/entities/reservation';
import { BookingContext } from 'src/contexts/BookingFlowContext';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface ISearchParamsOptions<T> {
    paramName: ModuleSearchParam;
}

const withSearchParams = <P extends IStepModuleProps, T extends object>(
    WrappedComponent: React.ComponentType<P>,
    options: ISearchParamsOptions<T>
) => {
    const WithSearchParams: React.FC<P> = (props) => {
        const context = useContext(BookingContext);
        const searchParam = !context.hasAutoSelected
            ? new URLSearchParams(window.location.search).get(options.paramName)
            : null;

        const searchParams = props.data.searchParams
            ? { ...props.data.searchParams, [options.paramName]: searchParam }
            : { [options.paramName]: searchParam };

        const extendedData = { ...props.data, searchParams };

        const newProps = { ...props, data: extendedData };

        return <WrappedComponent {...newProps} />;
    };

    return WithSearchParams;
};

export const getDateParam = (searchParams?: ISearchParams): string | undefined => {
    return searchParams?.Date || undefined;
};

export default withSearchParams;
